/*
 * Pill button. Variants: primary, ghost, secondary, danger.
 */
import React from 'react';
import { styled } from '@mui/material/styles';
import Icon from './Icon';

const base = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  height: 44,
  padding: '0 20px',
  borderRadius: 999,
  font: '500 14px/1 var(--gp-font)',
  cursor: 'pointer',
  transition: 'background 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease',
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },
};

const VARIANTS = {
  primary: {
    background: 'var(--gp-brand)',
    color: '#FFFFFF',
    border: 'none',
    '&:hover': { background: '#00422D' },
    '&:active': { transform: 'translateY(1px)' },
  },
  ghost: {
    background: 'transparent',
    color: 'var(--gp-brand)',
    border: '1px solid var(--gp-brand)',
    '&:hover': { background: 'var(--gp-lime-soft)' },
    '&:active': { transform: 'translateY(1px)' },
  },
  secondary: {
    background: 'var(--gp-accent)',
    color: '#FFFFFF',
    border: 'none',
    '&:hover': { background: '#3B6E57' },
    '&:active': { transform: 'translateY(1px)' },
  },
  danger: {
    background: 'var(--gp-danger-bg)',
    color: 'var(--gp-danger-fg)',
    border: '1px solid var(--gp-danger-border)',
    '&:hover': { background: '#FCEFEF' },
    '&:active': { transform: 'translateY(1px)' },
  },
};

const StyledButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ variant = 'primary' }) => ({ ...base, ...(VARIANTS[variant] || VARIANTS.primary) }));

function GpButton({ variant = 'primary', icon, children, ...rest }) {
  return (
    <StyledButton type="button" variant={variant} {...rest}>
      {typeof icon === 'string' ? <Icon name={icon} size={18} /> : icon}
      {children}
    </StyledButton>
  );
}

export default GpButton;
